module.exports = __webpack_public_path__ + "static/media/nr.2526a443.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nr.svg
// module id = 214
// module chunks = 0